var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNaves = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "71px",
    viewBox: "0 0 55 71",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "2FB60D8D-9190-438B-8CA9-1511C9812FD8")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inicio",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inicio_dollies",
    transform: "translate(-526.000000, -1414.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "moving",
    transform: "translate(0.000000, 1363.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(427.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(101.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "naves",
    transform: "translate(0.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.61667385,51.2927777 L49.1166738,51.2927777 L49.1166738,58.7927777 L1.61667385,58.7927777 L1.61667385,51.2927777 Z",
    id: "Path-7",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-8",
    strokeWidth: 3.5,
    strokeLinejoin: "round",
    points: "5.28054831 50.951708 5.28054831 34.5537876 5.28054831 16.3777421 45.5302708 16.3777421 45.5302708 34.7341547 45.5302708 50.951708"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-8",
    strokeWidth: 3.5,
    strokeLinejoin: "round",
    points: "5.28054831 46.5 0 46.5 0 22.0800215 0 0 51 0 51 22.299129 51 46.5 45.5302708 46.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18020825,34.8696235 L45.5302708,34.8696235",
    id: "Path-9",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 2,
    strokeLinejoin: "round",
    cx: 12.5,
    cy: 42.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 2,
    strokeLinejoin: "round",
    cx: 38.5,
    cy: 42.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-10",
    strokeWidth: 3.5,
    strokeLinejoin: "round",
    points: "6.04776126 59.2660523 6.04776126 67.1510036 13 67.1510036 13 59.2660523"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-10",
    strokeWidth: 3.5,
    strokeLinejoin: "round",
    points: "38.0477613 59.2660523 38.0477613 67.1510036 45 67.1510036 45 59.2660523"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNaves, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/naves.3ecdb5f6.svg";
export { ForwardRef as ReactComponent };